import { render, staticRenderFns } from "./ZurnalasNtrGaunami.vue?vue&type=template&id=5c1baf9c&scoped=true&"
import script from "./ZurnalasNtrGaunami.vue?vue&type=script&lang=js&"
export * from "./ZurnalasNtrGaunami.vue?vue&type=script&lang=js&"
import style0 from "./ZurnalasNtrGaunami.vue?vue&type=style&index=0&id=5c1baf9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1baf9c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VCol,VContainer,VDataTable,VFooter,VRow,VSpacer,VTooltip})
